import { createTheme } from '@mui/material/styles';

const getOverrides = () => ({
  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: 14,
        fontWeight: 400,
        textTransform: 'none',
      },
    },
  },
});

export const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
  },
  palette: {
    primary: {
      main: '#0E75BD',
    },
    secondary: {
      main: '#F9B756',
    },
    error: {
      main: '#f44336',
    },
    background: {
      section: '#f5f5f5',
    }
  },
  components: getOverrides(),  
});
